import { Modal, ModalProps } from '../Modal';
import styles from './ImageViewer.module.css';
import { LFC } from '../../types';

export interface ImageViewerProps extends Omit<ModalProps, 'className'> {}

export const ImageViewer: LFC<ImageViewerProps> = ({ children, ...props }) => {
  return (
    <Modal {...props} className={styles.modal}>
      <div className={styles.content}>{children}</div>
    </Modal>
  );
};
